import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14f9f01e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus-circle" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]


export default /*#__PURE__*/_defineComponent({
  props: {
    id: null,
    locked: { type: Boolean }
  },
  emits: ['addPoint'],
  setup(__props: any, { emit }) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "button",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('addPoint', __props.id))),
    disabled: __props.locked
  }, _hoisted_3, 8, _hoisted_1))
}
}

})